import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DataCardComponent} from "./data-card.component";
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import {NgApexchartsModule} from "ng-apexcharts";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { TotalEntriesExitsComponent } from '../cards/financial/entries/indicators/total-entries/total-entries-exits.component';
import { MembersQuantityComponent } from './members/members-quantity/members-quantity.component';



@NgModule({
  declarations: [
      DataCardComponent,
      MembersQuantityComponent,
  ],
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        NgApexchartsModule,
        MatProgressSpinnerModule,
    ],
    exports: [
        DataCardComponent,
        MembersQuantityComponent
    ]
})
export class DataCardModule { }
